import React from "react";
import TrinsicStart from "../trinsic/TrinsicStart";
import FinnishTrustNetworkLogo from "../../../assets/finnish_trust_network.svg";

const FinnishTrustNetworkStart = () => {
  return (
    <TrinsicStart
      providerName="FINNISH_TRUST_NETWORK"
      providerDisplayName="Finnish Trust Network"
      logo={FinnishTrustNetworkLogo}
      logoWidth={50}
      buttonColor="#072f88"
    />
  );
};

export default FinnishTrustNetworkStart;
